import { PageHeader, Popconfirm, Upload } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { EMPTY_MAT } from 'domains/matDomain';
import { isPlatformOrg } from 'domains/orgDomain';
import { useOrgId } from 'hooks/useOrg';
import { useTranslation } from 'react-i18next';

export const MatHeader = () => {
  const orgId = useOrgId();
  const isBaseOrg = isPlatformOrg({ id: orgId });
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const curItem = useAppSelector((state) => state.mat.item);
  const filterObj = useAppSelector((state) => state.mat.filterObj);
  const currentPage = useAppSelector((state) => state.mat.currentPage);

  const importLoading = useAppSelector(
    (state) => state.loading.effects.excelDefinition.importMaterials
  );
  const exportLoading = useAppSelector(
    (state) => state.loading.effects.excelDefinition.exportMaterials
  );

  const importFile = (
    <Upload
      maxCount={1}
      disabled={importLoading}
      showUploadList={false}
      customRequest={async (option) => {
        const formData = new FormData();
        formData.append('file', option.file);
        await dispatch.excelDefinition.importMaterials(formData);
        if (+currentPage === 1) {
          await dispatch.mat.getList({
            page: {
              currentPage: 1,
              pageSize: 20,
            },
            query: {
              ...filterObj,
            },
          });
        } else {
          dispatch.mat.setState({
            currentPage: 1,
          });
        }
      }}
    >
      <RevxButton key="import" brandGreen loading={importLoading}>
        {t('common.import')}
      </RevxButton>
    </Upload>
  );

  const exportFile = (
    <RevxButton
      key="export"
      brandGreen
      loading={exportLoading}
      onClick={() => {
        dispatch.excelDefinition.exportMaterials();
      }}
    >
      {t('common.export')}
    </RevxButton>
  );

  const createFromScratchButton = (
    <RevxButton
      key="fromScratch"
      disabled={!!curItem}
      brandGreen
      onClick={() =>
        dispatch.mat.setState({
          item: {
            ...EMPTY_MAT,
            isBase: isBaseOrg,
            isPublic: true,
            baseRefId: undefined,
          },
        })
      }
    >
      {t('platform.mat.createMatFromScratch')}
    </RevxButton>
  );

  const createFromBaseButton = (
    <RevxButton
      key="create"
      disabled={!!curItem}
      brandGreen
      onClick={() => dispatch.mat.setMatBaseSelectVisible(true)}
    >
      {t('platform.mat.createMatFromBase')}
    </RevxButton>
  );

  const removeAllButton = (
    <Popconfirm
      title={t('common.confirmQuestion')}
      onConfirm={async () => {
        await dispatch.mat.removeAll();
      }}
    >
      <RevxButton key="removeAll" brandOrange>
        {t('platform.mat.removeAll')}
      </RevxButton>
    </Popconfirm>
  );

  return (
    <PageHeader
      title={
        isBaseOrg
          ? t('platform.header.baseMaterials')
          : t('platform.header.materials')
      }
      ghost={false}
      className="platform-page-header"
      extra={
        isBaseOrg
          ? [exportFile, importFile, createFromScratchButton]
          : [
              removeAllButton,
              exportFile,
              importFile,
              createFromScratchButton,
              createFromBaseButton,
            ]
      }
    />
  );
};
